module.exports = __webpack_public_path__ + "static/media/hisopado_neg.96d8fe99.svg";